import { useEffect, useState } from 'react'

/**
 * Render children on only client side.
 * It is error-free component for SSR
 *
 * @prop children content to render only on client-side
 */

type Props = {
  tag?: keyof JSX.IntrinsicElements | React.ComponentType
  children: React.ReactNode
  className?: string
}

const ClientOnly: React.FC<Props> = ({
  children,
  className,
  tag: Tag = 'span'
}) => {
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    // https://nextjs.org/docs/messages/react-hydration-error
    setIsClient(true)
  }, [])

  if (!isClient) return null

  return <Tag className={className}>{children}</Tag>
}

export default ClientOnly
